import { render, staticRenderFns } from "./SubclientEditPage.vue?vue&type=template&id=3ee9ad2c&scoped=true"
import script from "./SubclientEditPage.vue?vue&type=script&lang=ts"
export * from "./SubclientEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee9ad2c",
  null
  
)

export default component.exports